export const FALLBACK_CURRENCY = 'CHF';
export const FALLBACK_COUNTRY = 'CH';
export const PLACEHOLDER_VALUE = '';
